package app.bloomey.web.pages.admin

import androidx.compose.runtime.*
import app.bloomey.web.components.layouts.AuthGuardReversed
import app.bloomey.web.components.modals.ModalHost
import app.bloomey.web.components.widgets.EnvironmentTag
import app.bloomey.web.components.widgets.SiteButton
import app.bloomey.web.components.widgets.SiteTextInput
import app.bloomey.web.core.res.*
import app.bloomey.web.modules.auth.AuthContract
import app.bloomey.web.modules.auth.AuthViewModel
import app.bloomey.web.theme.toSitePalette
import app.bloomey.web.utils.isValidEmail
import com.varabyte.kobweb.compose.css.AlignSelf
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import kotlinx.coroutines.flow.collectLatest
import org.jetbrains.compose.web.attributes.AutoComplete
import org.jetbrains.compose.web.attributes.ButtonType
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.dom.Form

@Page
@Composable
fun LoginPage() {
    var email by remember { mutableStateOf("") }
    var password by remember { mutableStateOf("") }
    val colorMode = ColorMode.current
    val router = rememberPageContext().router
    val scope = rememberCoroutineScope()
    val viewModel = remember(scope) { AuthViewModel(scope) }
    val state by viewModel.observeStates().collectAsState()
    val loginState = state.loginState
    val errorMessage = loginState.getMessage
    LaunchedEffect(Unit) {
        viewModel.observeStates().collectLatest {
            if (it.loginState.isSuccess) {
//                (document.getElementById(formId) as? HTMLFormElement)?.run {
//
//                }
                router.navigateTo(Res.Destinations.adminPage)
            }
        }
    }

    val clearState = {
        if (loginState.isError)
            viewModel.trySend(AuthContract.Inputs.ClearState)
    }

    AuthGuardReversed {
        Box(modifier = Modifier.fillMaxSize().maxHeight(100.vh), contentAlignment = Alignment.Center) {
            Column(
                horizontalAlignment = Alignment.CenterHorizontally,
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(leftRight = 16.px)
            ) {
                Image(
                    Res.Assets.logo,
                    modifier = Modifier.margin(bottom = 62.px).color(Colors.White)
                        .maxWidth(100.percent),
                    width = 200
                )
                Form(
                    attrs = Modifier
                        .maxWidth(100.percent)
                        .toAttrs {
                            attr("autocomplete", "on")
                        },
                ) {
                    Column(
                        modifier = Modifier
                            .width(500.px)
                            .maxWidth(100.percent)
                            .background(colorMode.toSitePalette().nearBackground)
                            .borderRadius(16.px)
                            .padding(leftRight = 20.px, top = 60.px, bottom = 50.px)
                    ) {
                        SiteTextInput(
                            text = email,
                            onChange = {
                                email = it
                                clearState()
                            },
                            label = "Email",
                            required = true,
                            leadingImage = Res.Assets.icEnvelope,
                            type = "email",
                            modifier = Modifier.fillMaxWidth().margin(bottom = 18.px),
                            autoComplete = AutoComplete.email
                        )
                        SiteTextInput(
                            label = "Password",
                            leadingImage = Res.Assets.icPassword,
                            password = true,
                            required = true,
                            text = password,
                            onChange = {
                                password = it
                                clearState()
                            },
                            modifier = Modifier.fillMaxWidth().margin(bottom = 30.px),
                            autoComplete = AutoComplete.currentPassword
                        )
                        Box(modifier = Modifier.minHeight(20.px).margin(bottom = 12.px).alignSelf(AlignSelf.Center)) {
                            errorMessage?.let {
                                SpanText(
                                    it,
                                    modifier = Modifier.color(Colors.Red)
                                )
                            }
                        }

                        SiteButton(
                            onClick = {
                                viewModel.trySend(AuthContract.Inputs.Login(email, password))
                            },
                            enabled = email.isValidEmail && password.isNotEmpty(),
                            loading = loginState.isLoading,
                            modifier = Modifier.fillMaxWidth(),
                            buttonType = ButtonType.Submit
                        ) {
                            SpanText(text = "Login")
                        }
                    }
                }
            }
            EnvironmentTag()
            ModalHost()
        }
    }
}